import React from 'react';

import Card from '@material-ui/core/Card';

import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
  card: {
    padding: '1% 2%',
    margin: '1%'
  },
  title: {
    fontSize: 14
  },
  avatarImg: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 5,
    width: 50,
    height: 50,
    borderRadius: '50%'
  }
});

export default function OneAccount({ account }) {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <Grid container spacing={1}>
        <img className={classes.avatarImg} alt='ad-img' src={account.logo} />
        <CardContent>
          <Typography className={classes.title} color='textSecondary' gutterBottom>
            Account Name : {account.name}
          </Typography>
        </CardContent>
      </Grid>
    </Card>
  );
}
